import { DropdownOption } from '@valk-nx/components/ui-dropdown/src/lib/dropdown.interface';
import { LinkListItem } from '@valk-nx/components/ui-link-list/src/lib/link-list.interface';
import { Language, LinkTarget } from '@valk-nx/core/lib/core';

export interface HeaderMenuItem {
	url: string;
	title: string;
	target?: LinkTarget;
	icon?: string;
}

export interface HeaderMenuButton {
	callback: CallableFunction;
	title?: string;
	icon?: string;
}

export interface CtaItem {
	title: string;
	url: string;
	target?: LinkTarget;
}

export interface CtaGroup {
	title: string;
	items: CtaItem[];
}

export function isCtaGroup(cta: CtaItem | CtaGroup): cta is CtaGroup {
	return 'items' in cta && cta.items.every((item) => 'title' in item);
}

export interface CtaGroupResolved {
	title: string;
	items: LinkListItem[];
}

export function isCtaGroupResolved(
	cta: CtaItem | CtaGroupResolved,
): cta is CtaGroupResolved {
	return 'items' in cta && cta.items.every((item) => 'text' in item);
}

export interface MetaMenu {
	languages?: {
		selectedLanguageOption: TranslatedSlug;
		options: DropdownOption[];
	};
	showSearch?: boolean;
	contactLink?: HeaderMenuItem;
	accountLink?: HeaderMenuItem;
	logoutButton?: HeaderMenuButton;
	cta?: CtaItem | CtaGroup;
}

export interface TranslatedSlug {
	selected: boolean;
	lang: Language;
	name: string;
	path: string;
}
